module.exports = __webpack_public_path__ + "media/images/common/h3_login-d8e5aa5517661d4b8f2ba4a26b6db4cc.gif";